export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE ? process.env.LOCALE : 'es-CO'

export const isThreeLivesCountry = ['es-EC', 'es-PE'].includes(LOCALE)

type TIds = { [key: string]: number[] }

type TPlayIds = { [key: string]: { [key: string]: number } }

const concourseIds: TPlayIds = {
  DEV: { 'es-CO': 590, 'es-PE': 595, 'es-EC': 599 },
  PDN: { 'es-CO': 687, 'es-PE': 715, 'es-EC': 714 },
}
export const concourseId = concourseIds[ENV][LOCALE]

const gameIds: TPlayIds = {
  DEV: { 'es-CO': 229, 'es-PE': 234, 'es-EC': 238 },
  PDN: { 'es-CO': 236, 'es-PE': 248, 'es-EC': 247 },
}
export const gameId = gameIds[ENV][LOCALE]

const listIds: {
  [key: string]: TIds
} = {
  DEV: {
    'es-CO': [230, 231, 232],
    'es-PE': [235, 236, 237],
    'es-EC': [239, 240, 241],
  },
  PDN: {
    'es-CO': [237, 238, 239],
    'es-EC': [241, 242, 243],
    'es-PE': [244, 245, 246],
  },
}

export const idsGameList = () => {
  return listIds[ENV][LOCALE]
}

export const costActivity = 30
export const costHelpActivity = 10

export const activity_dates = {
  'es-CO': ['4 de marzo del 2024', '31 de agosto del 2024'],
  'es-PE': ['8 de abril del 2024', '26 de noviembre 2024'],
  'es-EC': ['1 de abril del 2024', '30 de noviembre del 2024'],
}[LOCALE]

export const topNumber =
  {
    'es-CO': 10,
    'es-PE': 10,
    'es-EC': 10,
  }[LOCALE] || 10
